module.exports = __webpack_public_path__ + "static/media/screenshot-6.f009af89.png";